import { render, staticRenderFns } from "./BhUserPatients.vue?vue&type=template&id=846b4d96&scoped=true&"
import script from "./BhUserPatients.vue?vue&type=script&lang=js&"
export * from "./BhUserPatients.vue?vue&type=script&lang=js&"
import style0 from "./BhUserPatients.vue?vue&type=style&index=0&id=846b4d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846b4d96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
